import { render, staticRenderFns } from "./settingBaSalam.vue?vue&type=template&id=7ea960cd&scoped=true&"
import script from "./settingBaSalam.vue?vue&type=script&lang=js&"
export * from "./settingBaSalam.vue?vue&type=script&lang=js&"
import style0 from "./settingBaSalam.vue?vue&type=style&index=0&id=7ea960cd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ea960cd",
  null
  
)

export default component.exports